export const ATENCION_REQUEST = "ATENCION_REQUEST";
export const ATENCION_SUCCESS = "ATENCION_SUCCESS";
export const ATENCION_FAILURE = "ATENCION_FAILURE";
export const SET_ATENCION_ACTIVA = "SET_ATENCION_ACTIVA";
export const CLEAR_ATENCION_ACTIVA = "CLEAR_ATENCION_ACTIVA";
export const UPDATE_ATENCION_ITEMS = "UPDATE_ATENCION_ITEMS";
export const SET_SESIONES_ATENCION = "SET_SESIONES_ATENCION";
export const UPDATE_SESION_LOCAL = "UPDATE_SESION_LOCAL";
